import { render, staticRenderFns } from "./agen-naik-kelas.vue?vue&type=template&id=116fd580"
import script from "./agen-naik-kelas.vue?vue&type=script&lang=js"
export * from "./agen-naik-kelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports